"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function containsPoint(self, _a) {
    var x = _a.x, y = _a.y;
    return y > self.top && y < self.bottom && x > self.left && x < self.right;
}
exports.containsPoint = containsPoint;
function contains(self, _a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return (top >= self.top &&
        bottom <= self.bottom &&
        left >= self.left &&
        right <= self.right);
}
exports.contains = contains;
function collides(self, _a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return (self.left < right &&
        self.top < bottom &&
        self.right > left &&
        self.bottom > top);
}
exports.collides = collides;
function random(minOrMax, max) {
    var min;
    if (minOrMax == null) {
        min = 0;
        max = 1;
    }
    else if (max == null) {
        min = 0;
        max = minOrMax;
    }
    else {
        min = minOrMax;
    }
    return Math.random() * (max - min) + min;
}
exports.random = random;
